import React, { useRef, useState, useMemo } from 'react'
import { Header, Icon, Button } from 'semantic-ui-react'
import './Drenagem.scss'
import request from 'services/http'
import { toast } from 'react-toastify'
import { map, finalize } from 'rxjs/operators'
import history from 'services/history'
import { useSubscription } from 'utils'

function DrenagemUpload() {

    const fileFormRef = useRef()
    const filePhotoRef = useRef()
    const [fileFormPreview, setFileFormPreview] = useState(null)
    const [filePhotoPreview, setFilePhotoPreview] = useState(null)
    const [uploadData, setUploadData] = useState({ data: null, loading: false })

    const upload$ = useMemo(() => request({ method: 'POST', url: '/combustivel/drenagem/upload', body: uploadData.data }).pipe(
        map(({ response }) => {
            switch (response.status) {
                case 'attached':
                    toast.warn('Formulário já vinculado. Redirecionando para o lançamento.', {
                        autoClose: 4000,
                        onClose: () => history.push(`/combustivel/drenagem/lancamento/${response.id}`)
                    })
                break;

                case 'completed':
                    toast.warn('A drenagem da semana já foi realizada.', { autoClose: 4000 })
                break;

                default:
                    toast.success('Arquivos validados, redirecionando para o lançamento...', {
                        autoClose: 4000,
                        onClose: () => history.push(`/combustivel/drenagem/lancamento/${response.id}`)
                    })
            }
        }),
        finalize(() => setUploadData(prev => ({ ...prev, loading: false })))
    ), [uploadData.data])

    useSubscription(upload$, uploadData.loading)

    function handleFileChange() {
        const fileFormFile = fileFormRef.current.files
        const filePhotoFile = filePhotoRef.current.files

        if (fileFormFile.length > 0) {
            let reader = new FileReader()
            reader.onload = (e) => setFileFormPreview(e.target.result)
            reader.readAsDataURL(fileFormFile[0])
        }

        if (filePhotoFile.length > 0) {
            let reader = new FileReader()
            reader.onload = (e) => setFilePhotoPreview(e.target.result)
            reader.readAsDataURL(filePhotoFile[0])
        }

        if (fileFormFile.length > 0 && filePhotoFile.length > 0) {
            let data = new FormData()
            data.append('file_form', fileFormFile[0])
            data.append('file_photo', filePhotoFile[0])
            setUploadData({ data, loading: true })
        }
    }

    return (
        <div id="drenagem-lancamento-upload-page" className='page-content'>
            <Header size='medium' as='h2'>
                <Icon name='table' />
                <Header.Content>Listagem de Drenagens
                    <Header.Subheader style={{ fontSize: 15 }}>Ultimas drenagens</Header.Subheader>
                </Header.Content>
            </Header>

            <div className="row mt-5">
                <div className="col d-flex flex-column align-items-end mr-2">
                    <div id="img-preview">
                        {fileFormPreview && (<img src={fileFormPreview} alt='preview' />)}
                    </div>
                    <div>
                        <Button
                            style={{ width: 250, margin: 0 }}
                            color='blue'
                            as='label'
                            htmlFor='file-form'
                            className='mt-3'
                            content={<><Icon name='cloud upload' />Formulário</>}
                            loading={uploadData.loading}
                            disabled={uploadData.loading}
                        />
                        <input type="file" id="file-form" ref={fileFormRef} onChange={handleFileChange} hidden />
                    </div>
                </div>
                <div className="col d-flex flex-column align-items-start ml-2">
                    <div id="img-preview">
                        {filePhotoPreview && (<img src={filePhotoPreview} alt='preview' />)}
                    </div>
                    <div>
                        <Button
                            style={{ width: 250, margin: 0 }}
                            color='orange'
                            as='label'
                            htmlFor='file-photo'
                            className='mt-3'
                            content={<><Icon name='cloud upload' />Foto/Comprovante</>}
                            loading={uploadData.loading}
                            disabled={uploadData.loading}
                        />
                        <input type="file" id="file-photo" ref={filePhotoRef} onChange={handleFileChange} hidden />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DrenagemUpload
